var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex w-full justify-between items-center",attrs:{"id":"title-bar"}},[_c('div',{staticClass:"logo-title w-1/2"},[_c('ul',{staticClass:"w-full flex justify-start flex-wrap items-center col-gap-12 aisea-text-12-400-black h-12"},[_c('li',{staticClass:"title-logo"},[_c('logo-horizontal')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }